import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-ol-review',
  templateUrl: './video-ol-review.component.html',
  styleUrls: ['./video-ol-review.component.scss']
})
export class VideoOlReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
